function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { PadType } from "./constant/pad-type";

/**
 * 预处理后缀名，获取不带 . 文件后缀名
 * 判断是否是指定的文件后缀名
 */
export var isSpecifyLike = function isSpecifyLike(extTypes) {
  return function (fileExtension) {
    var cleanExt = fileExtension.replace(/^\./, '');
    return extTypes.includes(cleanExt);
  };
};

/**
 * 品类有一个上传新版本的入口。这个入口是限定对应的品类的格式的
 * 比如 doc 只能 传 doc 跟 docx 的文件。这里的 Accept 是传入 HTMLInputElement 的
 */
export var getAcceptFromPadType = function getAcceptFromPadType(padType) {
  var _PadTypeToAcceptMap, _PadTypeToAcceptMap2;
  var PadTypeToAcceptMap = (_PadTypeToAcceptMap = {}, _defineProperty(_PadTypeToAcceptMap, PadType.Sheet, ['.xlsx', '.xls', '.csv']), _defineProperty(_PadTypeToAcceptMap, PadType.Doc, ['.docx', '.doc']), _defineProperty(_PadTypeToAcceptMap, PadType.Slide, ['.pptx', '.ppt']), _PadTypeToAcceptMap);
  return (_PadTypeToAcceptMap2 = PadTypeToAcceptMap[padType]) !== null && _PadTypeToAcceptMap2 !== void 0 ? _PadTypeToAcceptMap2 : [];
};

// 跟产品聊了后 暂时每一个 对应 drive 文件都只能传 drive 自身后缀对应文件
// 比如 jpg 只能能传 jpg 、jpeg 都不行
// pdf 这里特化了 传了 mime 所以帮转 一层 原本是想做传后缀的做法的
export var getAcceptFromMimeTypeOrExt = function getAcceptFromMimeTypeOrExt(ext) {
  // 可能会有大写的后缀 所以统一先转小写
  var lowerCaseExt = ext.includes('.') ? ext.toLowerCase() : ".".concat(ext.toLowerCase());
  var doc = ['.docx', '.doc'];
  var xls = ['.xlsx', '.xls', '.csv'];
  var ppt = ['.ppt', '.pptx'];
  if (doc.includes(lowerCaseExt)) return doc;
  if (xls.includes(lowerCaseExt)) return xls;
  if (ppt.includes(lowerCaseExt)) return ppt;
  return [lowerCaseExt];
};
//# sourceMappingURL=util.js.map